import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import Logger from '../functions/logging';

import DeviceHelper from '../functions/device';
import * as TargetProcess from '../functions/targetProcess';
import * as authFns from '../functions/auth';

import localeMessages from '../locales/register';
import { setTargetParams } from '../redux/actions/index';
import { getGroup } from '../api/group';
import { validateDeviceInfo } from '../api/devices';
import { isAmazonPartnerStudy } from "../functions/study";

import { setFetchedGroup } from '../redux/actions/index';

const USER_AGENT = navigator.userAgent;
const FAKE_TRANSACTION_ID = "PORTAL_TEST_" + Math.floor((new Date()).getTime() / 1000);

class ProcessTargetUrl extends Component {
	constructor(props) {
		super(props);
		this.state = { 
			fetchedGroup: null,
			errors: {},
		};
	}

	async componentDidMount() {
		const { location, targetParams } = this.props;

		Logger.log(ProcessTargetUrl.name, "componentDidMount()", this.props, location.pathname, location.search);

		const locationSearch = location.search;
		const currentUrl = location.pathname + locationSearch;
		const studyLink = currentUrl ? currentUrl : authFns.getThirdPartyUrl();
		const panelPartner = TargetProcess.identifyPartnerFromUrl(studyLink);
		this.props.setPanelPartner(panelPartner);

		let paramsObject = this.setupTargetParams(null, locationSearch, currentUrl);

		Logger.log(this.constructor.name, "componentDidMount() paramsObject", paramsObject);

		if (paramsObject.gid) {
			await this.loadGroup(paramsObject.gid);
		}

		if (locationSearch && locationSearch.indexOf("gid=") > 0) {
			authFns.setSavedUrl(currentUrl);
		}

		await DeviceHelper.initializeBrowserDeviceData();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		Logger.log("ProcessTargetUrls: componentDidUpdate()", prevProps, this.props);

		if (this.props.targetParams && this.props.fetchedGroup) {

			let paramsObject = {};
			if (this.props.fetchedGroup.panel_segment && this.props.fetchedGroup.panel_segment.length) {
				let consentIndexes = [];

				this.props.fetchedGroup.panel_segment.forEach((panelSegment, index) => {
					if (this.props.targetParams.ps &&
						this.props.targetParams.ps == index &&
						panelSegment.screener_prompts &&
						panelSegment.screener_prompts.includes('voxpopme')
					) {
						// containsVideoResponseQuestion = true;
						paramsObject = Object.assign({ videoDisclaimer: true }, this.props.targetParams);
					}

					if (panelSegment.screener_prompts && 
						(panelSegment.screener_prompts.includes('ellation') 
						|| panelSegment.screener_prompts.includes('ellation-mx') 
						|| panelSegment.screener_prompts.includes('ellation-br') 
						|| panelSegment.screener_prompts.includes('amazon') 
						|| panelSegment.screener_prompts.includes('amazon-it')
						|| panelSegment.screener_prompts.includes('amazon-eu-es')
						|| panelSegment.screener_prompts.includes('amazon-es')
						|| panelSegment.screener_prompts.includes('amazon-mx') 
						|| panelSegment.screener_prompts.includes('amazon-de')
						|| panelSegment.screener_prompts.includes('amazon-br')
						|| panelSegment.screener_prompts.includes('amazon-ja') 
						|| panelSegment.screener_prompts.includes('netflix-us') 
						|| panelSegment.screener_prompts.includes('nda-prompt') 
						|| panelSegment.screener_prompts.includes('pilotly-nda'))
					) {
						consentIndexes.push(index);
						paramsObject = Object.assign({ viewerConsent: true, consentIndexes: consentIndexes }, this.props.targetParams);
					}
				});
				
				paramsObject = Object.assign(paramsObject, this.props.targetParams);
				let psRedirects = this.returnStudyRedirects(this.props.fetchedGroup, this.props.targetParams.ps);
				if (psRedirects
					&& !this.props.targetParams.redir
					&& !this.props.targetParams.err
					&& !this.props.targetParams.oq
					&& !this.props.targetParams.dq
				) {
					paramsObject = Object.assign(paramsObject, this.props.targetParams);
					paramsObject = Object.assign(paramsObject, psRedirects);
					paramsObject = this.setupTargetParams(paramsObject);
				}

				this.props.setTargetParams(paramsObject);
			}

			if (this.props.fetchedGroup.ps_select_enabled && !paramsObject.psselected) {
				this.props.history.push('/viewer-select');
			}
			else if (this.props.targetParams.sec) {
				this.props.history.push('/security');
			}
			else if (this.props.targetParams.nf) {
				this.props.history.push('/');
			}
			else {
				this.props.history.push('/register');
			}
		}
	}

	static getDerivedStateFromProps(nextProps, prevState) {
		Logger.log(ProcessTargetUrl.name, "getDerivedStateFromProps()", nextProps);

		authFns.checkThirdPartyEndDate();
		if (!nextProps.targetParams) {
			let paramsObject = TargetProcess.parseUrl(nextProps.location.search);
			paramsObject = TargetProcess.decodeRedirects(paramsObject);

			const isTester = TargetProcess.isTester(paramsObject);
			if (isTester) {
				authFns.removeThirdPartyUrl();
				if (paramsObject.transaction_id === "auto") {
					paramsObject.transaction_id = FAKE_TRANSACTION_ID;
				}
				if (paramsObject.partnerid === "auto") {
					paramsObject.partnerid = FAKE_TRANSACTION_ID;
				}
			}
			paramsObject = paramsObject.partner ? TargetProcess.partnerIdReplace(paramsObject) : paramsObject;
			paramsObject = paramsObject.publisher ? TargetProcess.publisherReplace(paramsObject) : paramsObject;
			if (paramsObject.partner || paramsObject.dl) {
				paramsObject['thirdPartyUrl'] = nextProps.location.pathname + nextProps.location.search;
			}
			paramsObject['fakeUser'] = paramsObject.partner || paramsObject.dl ? TargetProcess.createFakeUser(paramsObject, null) : null;
			paramsObject['reelchatUser'] = paramsObject.rch === '1' ? TargetProcess.createFakeUser(paramsObject, null) : null;
			nextProps.setTargetParams(paramsObject);
			return paramsObject;
		}
		else {
			return {};
		}
	}

	async loadGroup(gid) {
		Logger.log(this.constructor.name, "loadGroup()", gid);
		try {
			const result = await getGroup(gid);

			if (result) {
				Logger.log(this.constructor.name, "loadGroup() getGroup result", result);
				this.setState({ fetchedGroup: result }, () => {
					this.props.setFetchedGroup(result);
				});
			}
			else {
				this.setState({ loading: false });
				Logger.log(this.constructor.name, "loadGroup() No result");
				let errors = { ...this.state.errors };
				errors["status"] = this.props.intl.formatMessage(localeMessages.error_study_loading_info);
				this.setState({ errors });
			}
		}
		catch (error) {
			this.setState({ loading: false });
			let errors = { ...this.state.errors };
			Logger.error(this.constructor.name, "loadGroup() error", error);
			errors["status"] = this.props.intl.formatMessage(localeMessages.error_study_loading_info);
			this.setState({ errors });
		}
	}

	async redirectOnDeviceValidation(userAgent) {
		Logger.log(this.constructor.name, "redirectOnDeviceValidation() isMobile", DeviceHelper.isMobile);

		if (DeviceHelper.isMobile) {

			//The logic implemented inside the API endpoint /validate/devices isn't identifying iPad as a mobile device.
 
			const isSafariOnIpad = DeviceHelper.isIOS && DeviceHelper.isTablet && DeviceHelper.isSafari;

			Logger.log(this.constructor.name, "redirectOnDeviceValidation() isSafariOnIpad", isSafariOnIpad);

			if (!isSafariOnIpad) {

				Logger.log(this.constructor.name, "redirectOnDeviceValidation() USER AGENT:", userAgent);

				try {

					const result = await validateDeviceInfo(userAgent);

					if (result) {

						Logger.log(this.constructor.name, "redirectOnDeviceValidation() result", result);

						if (!result.data.valid) {
							this.props.history.push('/mobile-redirect');
						}
					}
					else {
						Logger.log(this.constructor.name, "redirectOnDeviceValidation() No device result");
						this.props.history.push('/mobile-redirect');
					}
				}
				catch (error) {
					Logger.error(this.constructor.name, "redirectOnDeviceValidation() error", error);
					this.props.history.push('/mobile-redirect');
				}
			}
		}
	}

	returnStudyRedirects(group, ps) {
		if (group 
			&& group.panel_segment 
			&& group.panel_segment.length
			&& (ps || ps == 0)
			&& group.panel_segment[ps]
			&& group.panel_segment[ps].redirects
		) {
			return group.panel_segment[ps].redirects;
		}

		return null;
	}

	setupTargetParams(params, locationSearch, currentUrl) {
		let paramsObject = params ? params : TargetProcess.parseUrl(locationSearch);
		const isTester = TargetProcess.isTester(paramsObject);

		if (isTester) {
			authFns.removeThirdPartyUrl();
			if (paramsObject.transaction_id === "auto") {
				paramsObject.transaction_id = FAKE_TRANSACTION_ID;
			}
			if (paramsObject.partnerid === "auto") {
				paramsObject.partnerid = FAKE_TRANSACTION_ID;
			}
		}

		paramsObject = TargetProcess.decodeRedirects(paramsObject);

		paramsObject = paramsObject.partner ? TargetProcess.partnerIdReplace(paramsObject) : paramsObject;
		paramsObject = paramsObject.publisher ? TargetProcess.publisherReplace(paramsObject) : paramsObject;
		if (paramsObject.partner || paramsObject.dl) { paramsObject['thirdPartyUrl'] = currentUrl; }

		paramsObject['fakeUser'] = paramsObject.partner || paramsObject.dl || paramsObject.client ? TargetProcess.createFakeUser(paramsObject, null) : null;

		return paramsObject;
	}

	hasErrors() {
		return Object.keys(this.state.errors).length ? true : false;
	}

	render() {
		Logger.log(this.constructor.name, "render()", this.props, this.state);
		const { errors } = this.state;
		const url = new URL(window.location.href);
		authFns.setSavedUrl(url.pathname + url.search);

		return (
			<div className="process-target-url">
				{this.hasErrors() && errors["status"]}
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		currentUser: state.currentUser.currentUser,
		fetchedGroup: state.targetProcess.fetchedGroup,
		targetParams: state.targetProcess.targetParams
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
		setFetchedGroup,
		setTargetParams
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(ProcessTargetUrl));


// WEBPACK FOOTER //
// ./src/pages/ProcessTargetUrl.js